import { restClient } from '@/Core'

import { toPrincipalOption } from '../Helpers/diskResponse'

import type { DiskPrincipalOption } from '../Contracts/DiskShare'

/** Кому можна надати доступ: `GET /services/disk/principals?q=` (без запиту — мої відділи, ролі, компанія). */
export const SearchDiskPrincipalsTask = async (query: string): Promise<DiskPrincipalOption[]> => {
    const response = (await restClient.get(
        '/services/disk/principals',
        { searchParams: { q: query } },
        { forceRefresh: true }
    )) as unknown
    const items = (response as { items?: unknown } | null)?.items

    return Array.isArray(items) ? items.map(toPrincipalOption) : []
}
